var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Alert'),_c('Banner',{attrs:{"picture":_vm.bannerImg,"title":_vm.pageTitle}}),_c('main',{staticClass:"col-md-12",attrs:{"role":"main"}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }